import { PrivacyNotice } from '@babylon/consumer-api/types'
import { Field } from '@/types/partnerConfig'
import { noticeTypeToFieldName } from '@/constants'
import { NoticeCheckbox } from '@/components'

const getNoticeField = (
  notice: PrivacyNotice,
  validateMessage: string,
  useDnaV2Design: Boolean
): Field => ({
  name: noticeTypeToFieldName[notice.noticeType!] || 'notice',
  type: 'custom',
  disabled: false,
  required: Boolean(notice.mandatory),
  Component: NoticeCheckbox,
  props: {
    notice,
    validateMessage,
    useDnaV2Design,
  },
})

export default getNoticeField
